(() => {
  // app/scripts/common/function/collection-filter.js
  var collectionFilter = class extends HTMLElement {
    constructor() {
      super();
      this.cache = [];
      this.container = this.closest("[data-section-type]");
      this.andLogic = JSON.parse(this.dataset.andLogic);
      this.filterType = this.dataset.type || "groups";
      this.form = this.querySelector("form");
      this.inputClass = `input[form="${this.form.id}"]`;
      this.addEvents();
    }
    addEvents() {
      var maxInput = this.container.querySelector("#max-input");
      var minInput = this.container.querySelector("#min-input");
      var maxVal = parseFloat(maxInput.max);
      if (maxInput != null) {
        maxInput.addEventListener("change", function() {
          let v = parseInt(this.value);
          if (v < 1)
            this.value = 1;
          if (v > maxVal)
            this.value = maxVal;
          if (v < minInput.value) {
            let temp = this.value;
            this.value = minInput.value;
            minInput.value = temp;
          }
        });
      }
      if (minInput != null) {
        minInput.addEventListener("change", function() {
          let v = parseInt(this.value);
          if (v < 1)
            this.value = 1;
          if (v > maxVal)
            this.value = maxVal;
          if (v > maxInput.value) {
            let temp = this.value;
            this.value = maxInput.value;
            maxInput.value = temp;
          }
        });
      }
      let timeout = 100;
      const inputList = this.container.querySelectorAll(this.inputClass);
      inputList.forEach((input) => {
        input.addEventListener("change", () => {
          if (input.type == "checkbox") {
            if (input.checked) {
              this.onCheck(input);
            } else {
              this.onUnCheck(input);
            }
          } else {
            this.submit();
          }
        });
      });
      let clearFilterButtons = this.container.querySelectorAll(".clear-filter");
      clearFilterButtons.forEach((e) => {
        let inputs_cotainer = e.parentElement.nextElementSibling;
        if (inputs_cotainer.querySelector(".active-filter")) {
          e.classList.remove("hidden");
        }
        e.addEventListener("click", () => {
          this.onClear(e);
        });
      });
      let sortButtons = this.container.querySelectorAll(".sort-action");
      sortButtons.forEach((e) => {
        e.addEventListener("click", () => {
          this.container.querySelector(".name a").innerHTML = e.innerHTML;
          this.container.querySelector("#cata_sort_by").setAttribute("data-sort", e.dataset.sort);
          sortButtons.forEach((ele) => ele.classList.remove("active"));
          e.classList.add("active");
          this.submit();
        });
      });
      let sticky_sort = this.container.querySelector("#sticky-sort");
      sticky_sort.addEventListener("change", () => {
        this.container.querySelector("#cata_sort_by").setAttribute("data-sort", sticky_sort.value);
        this.submit();
      });
      let loadButton = this.container.querySelector(".btn-load-more");
      if (loadButton != null) {
        loadButton.addEventListener("click", (e) => {
          e.preventDefault();
          this.onLoadMore();
        });
      }
      let gridButton = this.container.querySelector(".grid-list .grid");
      let listButton = this.container.querySelector(".grid-list .list");
      return;
      this.container.querySelectorAll("input.js-popup-init")?.forEach((input) => {
        input.addEventListener("change", (e) => {
          const value = input.value;
          const target = this.container.querySelector(`.js-filter[value="${value}"]`);
          if (!target)
            return;
          target.checked = input.checked;
          if (target.closest("#sortPopup")) {
            this.container.querySelectorAll("#sortPopup :checked")?.forEach((i) => {
              i.checked = i == target;
            });
            target.dispatchEvent(new Event("change"));
          }
        });
      });
      this.container.querySelector(".js-popup-close").addEventListener("click", (e) => {
        setTimeout(() => {
          this.updateFilterPopup();
        }, 500);
      });
    }
    onCheck(input) {
      input.checked = true;
      let filter = input.parentElement;
      let parent = filter.parentElement.parentElement;
      let current = parent.querySelector(".active-filter");
      if (current != null && this.andLogic == false) {
        current.classList.remove("active-filter");
        current.querySelector("input").checked = false;
        current.querySelector(".checkmark_after").style.display = "none";
      }
      let clearFilter = input.parentElement.parentElement.parentElement.previousElementSibling.querySelector(".clear-filter");
      clearFilter.classList.remove("hidden");
      filter.classList.add("active-filter");
      this.submit();
    }
    onUnCheck(input) {
      input.checked = false;
      input.parentElement.classList.remove("active-filter");
      input.parentElement.querySelector(".checkmark_after").style.display = "none";
      let remain_actives = input.parentElement.parentElement.parentElement.querySelectorAll(".active-filter");
      if (remain_actives.length > 0) {
      } else {
        input.parentElement.parentElement.parentElement.previousElementSibling.querySelector(".clear-filter").classList.add("hidden");
      }
      this.submit();
    }
    onClear(button) {
      let container = button.parentElement.nextElementSibling;
      let active_inputs = container.querySelectorAll(".active-filter input");
      active_inputs.forEach((e) => {
        e.checked = false;
        e.parentElement.classList.remove("active-filter");
        e.parentElement.querySelector(".checkmark_after").style.display = "none";
      });
      this.submit();
      button.classList.add("hidden");
    }
    onLoadMore() {
      var Url = document.querySelector(".load_more a").getAttribute("href");
      let loading = document.querySelector(".new-loading");
      loading.classList.add("loading");
      fetch(Url).then((e) => e.text()).then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        let items = div.querySelectorAll(".products-grid-item");
        let newButton = div.querySelector(".load_more a");
        if (newButton != null) {
          let newUrl = newButton.getAttribute("href");
          document.querySelector(".load_more a").setAttribute("href", newUrl);
        } else
          document.querySelector(".load_more").style.display = "none";
        let container = document.querySelector(".cata-product");
        const cookie_modeView = ("; " + document.cookie).split(`; mode-view=`).pop().split(";")[0];
        let num = this.container.querySelector(".cata-toolbar").dataset.gridCol;
        items.forEach((e) => {
          container.appendChild(e);
          e.classList.remove("number-1", "number-3", "number-4", "number-5", "products-grid-item", "products-list-item", "loading");
          if (cookie_modeView == "list") {
            e.classList.add("products-list-item");
            e.classList.add("number-1");
            let lists = document.querySelectorAll(".grid-list .list");
            lists.forEach((e2) => {
              e2.classList.add("active");
            });
            e.querySelector(".product-content").classList.add("hide");
            e.querySelector(".product-list-content").classList.remove("hide");
          } else {
            e.classList.add("products-grid-item");
            e.classList.add(`number-${num}`);
            let grids = document.querySelectorAll(".grid-list .grid");
            grids.forEach((e2) => {
              e2.classList.add("active");
            });
            e.querySelector(".product-content").classList.remove("hide");
            e.querySelector(".product-list-content").classList.add("hide");
          }
        });
        div.remove();
        loading.classList.remove("loading");
      });
    }
    getQueryString() {
      const formData = new FormData(this.form);
      const query = new URLSearchParams(formData);
      if (this.filterType == "groups")
        return query.toString();
      const arrayFilter = [];
      let sort = "";
      query.toString().split("&").map((i) => {
        !i.includes("sort_by=") ? arrayFilter.push(i.split("=")[1]) : sort = i;
      });
      return arrayFilter.join("+") + (sort.length ? `?${sort}` : "");
    }
    submit() {
      let query = this.getQueryString();
      if (window.innerWidth > 992) {
        var sort_query = document.querySelector(".sort-action.active").dataset.sort;
      } else {
        var sort_query = document.querySelector(".mobile-layout-bar .select-sort").value;
      }
      query += this.filterType == "groups" || query.includes("?") ? "&" : "?";
      query += `sort_by=${sort_query}`;
      let url = this.form.action;
      url += this.filterType == "groups" ? "?" : "/";
      url += query;
      url += this.filterType == "groups" || query.includes("?") ? "&" : "?";
      url += `section_id=${this.container.dataset.sectionId}`;
      let loading = document.getElementsByClassName("new-loading")[0];
      let body = document.querySelector("body");
      loading.classList.add("loading");
      body.classList.add("hide-scroll");
      fetch(url).then((e) => e.text()).then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        this.cache.push({
          query,
          DOM: div
        });
        this.render(div, query);
        div.remove();
        loading.classList.remove("loading");
        body.classList.remove("hide-scroll");
      });
    }
    render(result, searchParams = null) {
      let currents_number = this.container.querySelectorAll(".current-active");
      currents_number.forEach((e) => {
        e.innerText = 0;
      });
      if (true) {
        let splitCharacter = this.filterType == "groups" ? "?" : !searchParams.includes("?") || searchParams.includes("?") && searchParams.split("?")[0].length ? "/" : "";
        history.pushState({ searchParams }, "", `${this.form.action}${searchParams && splitCharacter.concat(searchParams)}`);
      }
      const nInputList = result.querySelectorAll(this.inputClass);
      const inputList = this.container.querySelectorAll(this.inputClass);
      this.container.querySelector(".collection_content").innerHTML = result.querySelector(".collection_content").innerHTML;
      let newButton = result.querySelector(".load_more");
      if (newButton != null) {
        this.container.querySelector(".btn-load-more").addEventListener("click", (e) => {
          e.preventDefault();
          this.onLoadMore();
        });
      }
      const cookie_modeView = ("; " + document.cookie).split(`; mode-view=`).pop().split(";")[0];
      let modeItems = this.container.querySelectorAll(".templateCollection .mode-view-item");
      let num = this.container.querySelector(".cata-toolbar").dataset.gridCol;
      modeItems.forEach((e) => {
        e.classList.remove("number-1", "number-3", "number-4", "number-5", "products-grid-item", "products-list-item", "loading");
      });
      if (cookie_modeView == "list") {
        modeItems.forEach((e) => {
          e.classList.add("products-list-item");
          e.classList.add("number-1");
          let lists = document.querySelectorAll(".grid-list .list");
          lists.forEach((e2) => {
            e2.classList.add("active");
          });
          e.querySelector(".product-content").classList.add("hide");
          e.querySelector(".product-list-content").classList.remove("hide");
        });
      } else {
        modeItems.forEach((e) => {
          e.classList.add("products-grid-item");
          e.classList.add(`number-${num}`);
          let grids = document.querySelectorAll(".grid-list .grid");
          grids.forEach((e2) => {
            e2.classList.add("active");
          });
          e.querySelector(".product-content").classList.remove("hide");
          e.querySelector(".product-list-content").classList.add("hide");
        });
      }
    }
  };
  customElements.define("collection-filter", collectionFilter);

  // app/scripts/common/function/collection-paginate.js
  var collectionInfinite = class extends HTMLElement {
    constructor() {
      super();
      this.submitBtn = this.querySelector("button");
      this.submitBtn.addEventListener("click", (e) => {
        this.fetch();
      });
    }
    fetch() {
      const sectionId = this.closest("[data-section-id]").dataset.sectionId;
      const key = this.dataset.key;
      const url = `${this.dataset.url}${this.dataset.url.includes("?") ? "&" : "?"}section_id=${sectionId}&${key}`;
      this.loading();
      fetch(url).then((e) => e.text()).then((e) => {
        this.parentNode.remove();
        const div = document.createElement("div");
        div.innerHTML = e;
        const container = document.querySelector(this.dataset.container);
        container.innerHTML += div.querySelector(this.dataset.container).innerHTML;
        document.querySelectorAll(".js-collection-update")?.forEach((item) => {
          const newItem = div.querySelector(`[class="${item.className}"]`);
          if (!newItem)
            return;
          item.innerHTML = newItem.innerHTML;
        });
        this.submitBtn.innerText = "Load More";
      });
    }
    loading() {
      this.classList.add("loading");
      if (!this.submitBtn.querySelector(".icon-loading")) {
        this.submitBtn.innerText = "";
        this.svgLoading = document.querySelector("#svg_loading svg")?.cloneNode(true);
        this.svgLoading.id = "loadingSVG";
        this.submitBtn.insertAdjacentElement("afterbegin", this.svgLoading);
      }
      this.submitBtn.toggleAttribute("disabled", true);
    }
  };
  customElements.define("collection-infinite-load", collectionInfinite);

  // app/scripts/collection-page.js
  window.addEventListener("DOMContentLoaded", (event) => {
    let girdList = document.querySelector(".grid-list");
    if (girdList != null) {
      handleGridList_Remove = () => {
        let items = document.querySelectorAll(".mode-view-item");
        items.forEach((e) => {
          e.classList.remove("number-1", "number-3", "number-4", "number-5", "products-grid-item", "products-list-item", "loading");
        });
        let grids = document.querySelectorAll(".grid-list .grid");
        let lists = document.querySelectorAll(".grid-list .list");
        grids.forEach((e) => {
          e.classList.remove("active");
        });
        lists.forEach((e) => {
          e.classList.remove("active");
        });
      };
      handleGridList = () => {
        handleGridList_Remove();
        let num = document.querySelector(".cata-toolbar").dataset.gridCol;
        var modeItems = document.querySelectorAll(".templateCollection .mode-view-item");
        var today = new Date();
        var expire = new Date();
        expire.setTime(today.getTime() + 36e5 * 24);
        const cookie_modeView = ("; " + document.cookie).split(`; mode-view=`).pop().split(";")[0];
        if (cookie_modeView == "list") {
          modeItems.forEach((e) => {
            e.classList.add("products-list-item");
            e.classList.add("number-1");
            document.querySelector(".grid-list .list").classList.add("active");
            let lists = document.querySelectorAll(".grid-list .list");
            lists.forEach((e2) => {
              e2.classList.add("active");
            });
            e.querySelector(".product-content").classList.add("hide");
            e.querySelector(".product-list-content").classList.remove("hide");
          });
        } else {
          modeItems.forEach((e) => {
            e.classList.add("products-grid-item");
            e.classList.add(`number-${num}`);
            let grids = document.querySelectorAll(".grid-list .grid");
            grids.forEach((e2) => {
              e2.classList.add("active");
            });
            e.querySelector(".product-content").classList.remove("hide");
            e.querySelector(".product-list-content").classList.add("hide");
          });
        }
        setTimeout(function() {
          document.querySelector(".mode-view-item").classList.remove("loading");
        }, 500);
        let mode_view_grids = document.querySelectorAll(".grid");
        mode_view_grids.forEach((ele) => {
          ele.addEventListener("click", () => {
            handleGridList_Remove();
            document.cookie = `mode-view=grid; expires=${expire.toGMTString()} ; path=/`;
            let modeItems2 = document.querySelectorAll(".templateCollection .mode-view-item");
            modeItems2.forEach((e) => {
              e.classList.add("products-grid-item");
              e.classList.add(`number-${num}`);
              e.querySelector(".product-list-content").classList.add("hide");
              e.querySelector(".product-content").classList.remove("hide");
              let mode_view_grids2 = document.querySelectorAll(".grid-list .grid");
              mode_view_grids2.forEach((element) => {
                element.classList.add("active");
              });
            });
          });
        });
        let mode_view_lists = document.querySelectorAll(".list");
        mode_view_lists.forEach((ele) => {
          ele.addEventListener("click", () => {
            handleGridList_Remove();
            document.cookie = `mode-view=list; expires=${expire.toGMTString()} ; path=/`;
            let modeItems2 = document.querySelectorAll(".templateCollection .mode-view-item");
            modeItems2.forEach((e) => {
              e.classList.add("products-list-item");
              e.classList.add(`number-1`);
              e.querySelector(".product-list-content").classList.remove("hide");
              e.querySelector(".product-content").classList.add("hide");
              let mode_view_lists2 = document.querySelectorAll(".grid-list .list");
              mode_view_lists2.forEach((element) => {
                element.classList.add("active");
              });
            });
          });
        });
      };
      handleGridList();
    }
    const slideToggle = (container) => {
      if (container.style.display == "none") {
        container.style.display = "block";
        container.style.height = "auto";
        var height = container.offsetHeight * 1 + 30 + "px";
        container.style.height = "0px";
        setTimeout(function() {
          container.style.height = height;
        }, 0);
      } else {
        container.style.height = "0px";
        container.addEventListener("transitionend", function() {
          container.style.display = "none";
        }, {
          once: true
        });
      }
    };
    fixNoScroll = () => {
      var windowW = document.body.clientWidth;
      document.querySelectorAll("#page-body, .header-content, #page-body .mobile-version").forEach((e) => {
        e.style.width = `${windowW}px`;
      });
    };
    fixReturnScroll = () => {
      document.querySelector("#page-body, .header-content,#page-body .mobile-version").setAttribute("style", "");
      let body = document.querySelector("body");
      body.classList.remove("menu-opened");
      body.style.paddingRight = "0px";
      body.setAttribute("style", "");
      body.removeAttribute("style");
    };
    toggleFilterSidebar = () => {
      let toggles = document.querySelectorAll(".filter-icon.toggle");
      if (toggles != null) {
        toggles.forEach((toggle) => {
          toggle.addEventListener("click", () => {
            let filter = document.querySelector(".filter-component");
            slideToggle(filter);
          });
        });
      }
      let drawers = document.querySelectorAll(".filter-icon.drawer");
      let filter_toggle = document.querySelector(".filter-icon.toggle");
      if (drawers && filter_toggle == null) {
        let filter = document.querySelector(".filter-component");
        filter.addEventListener("click", (event2) => {
        });
        filter.removeAttribute("style");
        drawers.forEach((drawer) => {
          drawer.addEventListener("click", (e) => {
            filter.style.display = "block";
            e.stopPropagation();
            fixNoScroll();
            document.querySelector("body").classList.add("sidebar-opened");
          });
        });
      }
      document.querySelector("#page-body").addEventListener("click", () => {
        if (document.querySelector("body").classList.contains("sidebar-opened") || document.querySelector("body").classList.contains("order-sidebar-opened")) {
          document.querySelector("body").classList.remove("sidebar-opened", "order-sidebar-opened");
          fixReturnScroll();
        }
      });
      document.querySelector(".f-close").addEventListener("click", () => {
        document.querySelector("#sidebar").classList.remove("opened");
        document.querySelector("body").classList.remove("sidebar-opened");
        fixReturnScroll();
      });
      let iconOrder = document.querySelector("filter-icon-order");
      if (iconOrder != null) {
        iconOrder.addEventListener("click", (e) => {
          e.stopPropagation();
          fixNoScroll();
          document.querySelector("body").classList.toggle("order-sidebar-opened");
        });
      }
      let close = document.querySelectorAll(".fof-close");
      if (close != null) {
        close.forEach((e) => {
          e.addEventListener("click", () => {
            document.querySelector("html,body").classList.remove("order-sidebar-opened");
            fixReturnScroll();
          });
        });
      }
    };
    toggleFilterSidebar();
    sidebar_menu_handle = () => {
      let elements = document.querySelectorAll(".categories-menu .dropdown .expand ,.sidebar-column .sb-filter");
      elements.forEach((e) => {
        e.addEventListener("click", () => {
          if (e.classList.contains("active") && !e.classList.contains("del-before")) {
            e.classList.remove("active");
            e.parentElement.classList.remove("active");
          } else {
            if (!e.classList.contains("del-before")) {
              e.classList.remove("active");
            }
            e.classList.add("active");
            e.parentElement.classList.add("active");
          }
        });
      });
      if (document.getElementsByClassName("grid-uniform").length) {
        document.querySelectorAll(".grid-uniform").forEach((e) => {
          if (e.querySelector(".advanced-filters").childElementCount == 0) {
            e.parentElement.parentElement.remove();
          }
        });
      }
    };
    sidebar_menu_handle();
    function getWidth() {
      return Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.documentElement.clientWidth);
    }
    function getHeight() {
      return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.documentElement.clientHeight);
    }
    resizeCollection = () => {
      if (document.querySelector("body").classList.contains("templateCollection")) {
        let sb = document.querySelectorAll(".sidebar-column"), filter_height = document.querySelector(".mobile-layout-bar").clientHeight;
        if (getWidth() < 992) {
          document.querySelector("#footer-content").style.marginBottom = `${filter_height}px`;
          let filterComponent = document.querySelector(".filter-component");
          filterComponent.style.display = "none";
          filterComponent.classList.remove("accordion", "toggle", "full");
          filterComponent.classList.add("drawer");
          if (sb.length > 0) {
            document.querySelectorAll(".sb-widget .sbw-filter").forEach((e) => {
              document.querySelector(".filter-component.drawer").appendChild(e);
            });
          }
          let drawers = document.querySelectorAll(".filter-icon.drawer");
          if (drawers) {
            let filter = document.querySelector(".filter-component");
            let filter_price = document.querySelector(".sb-filter.price");
            if (filter_price != null) {
              filter_price.addEventListener("click", (event2) => {
                event2.stopPropagation();
              });
            }
            filter.removeAttribute("style");
            drawers.forEach((drawer) => {
              drawer.addEventListener("click", (e) => {
                filter.style.display = "block";
                e.stopPropagation();
                fixNoScroll();
                document.querySelector("body").classList.add("sidebar-opened");
              });
            });
          }
        } else {
          document.querySelector("body").classList.remove("sidebar-opened", "order-sidebar-opened");
          fixReturnScroll();
          document.querySelector("#footer-content").style.marginBottom = "0px";
          document.querySelector(".filter-component").classList.remove("drawer");
          let style = document.querySelector(".cata-toolbar").dataset.filter;
          document.querySelector(".filter-component").classList.add(`${style}`);
          if (style == "toggle") {
            document.querySelector(".filter-component").style.display = "none";
          }
          if (sb.length > 0) {
            document.querySelectorAll(".sb-widget").forEach((e) => {
              if (e.dataset.prefix) {
                let filter = document.querySelector(".filter-component");
                if (filter) {
                  let filterPrefix = filter.querySelector(`.sb-filter.${e.dataset.prefix}`);
                  if (filterPrefix) {
                    let filterP = filter.querySelector(`.sb-filter.${e.dataset.prefix}`).parentElement;
                    if (filterP) {
                      let element = filterP.parentElement;
                      if (element)
                        e.appendChild();
                    }
                  }
                }
              }
            });
            document.querySelector("#page-body").click();
          }
        }
      }
    };
    resizeCollection();
    const debounce = (func, delay) => {
      let debounceTimer;
      return function() {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), delay);
      };
    };
    window.addEventListener("resize", debounce(function() {
      resizeCollection();
    }), 450);
  });
})();
